import { cloneDeep } from 'lodash'

import { components } from '@/utils'

import dialog from '@/components/rules/commons/dialog'
import item from '@/components/rules/commons/item'
import { baseClass } from '@/components/rules/utils'

function renderDialog(h) {
  return h(
    dialog,
    {
      props: {
        value: cloneDeep(this.proxy[this.tag]),
        show: this.showDialog,
        tag: this.tag,
        ruleType: this.ruleType
      },
      on: {
        show: event => {
          this.showDialog = event
        },
        input: event => {
          this.$set(this.proxy, this.tag, event)
        },
        tag: event => {
          this.tag = event
        }
      }
    }
  )
}

function renderItem(h, tag) {
  return h(
    item,
    {
      props: {
        tag,
        value: this.proxy[tag],
        ruleType: this.ruleType
      },
      on: {
        dialog: event => {
          this.tag = tag
          this.showDialog = event
        },
        clear: () => {
          this.$delete(this.proxy, tag)
        }
      }
    }
  )
}
function renderItems(h) {
  return this.items.map(item => {
    return renderItem.call(this, h, item)
  })
}

export default function(h) {
  return h(
    components.card,
    {
      class: `${baseClass}-card`,
      props: {
        title: this.getTranslate(`${baseClass}.titles.${this.ruleType}`),
        dashed: true,
        outline: true,
        rounded: true
      }
    },
    [
      renderItems.call(this, h),
      renderDialog.call(this, h)
    ]
  )
}
